{
  "name": "tiime-legal",
  "version": "2.13.1",
  "engines": {
    "pnpm": ">=10",
    "node": ">=24"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "red": "ng serve -c red",
    "teal": "ng serve -c teal",
    "amaranth": "ng serve -c amaranth",
    "test": "ng test",
    "lint": "ng lint --quiet",
    "lint-fix": "ng lint --fix",
    "lint-ci:all": "bash ./scripts/lint-ci.sh",
    "test-ci:all": "bash ./scripts/test-ci.sh",
    "build-ci:all": "bash ./scripts/build-ci.sh",
    "build-cd:red": "bash ./scripts/build-cd.sh red",
    "build-cd:teal": "bash ./scripts/build-cd.sh teal",
    "build-cd:amaranth": "bash ./scripts/build-cd.sh amaranth",
    "build-cd:development": "bash ./scripts/build-cd.sh development",
    "build-cd:production": "bash ./scripts/build-cd.sh production",
    "build-cd:school": "bash ./scripts/build-cd.sh school",
    "build-cd:dynamic": "bash ./scripts/build-cd.sh dynamic",
    "build:libs": "pnpm run build:tiime-components && pnpm run copy-fonts:tiime-components && pnpm run copy-assets:tiime-components",
    "build:libs:win": "pnpm run build:tiime-components && pnpm run copy-fonts-win:tiime-components && pnpm run copy-assets-win:tiime-components",
    "build:tiime-components": "pnpm run build tiime-components",
    "copy-fonts:tiime-components": "mkdir -p ./dist/tiime-components/fonts && cp -R ./projects/tiime-components/src/lib/tiime-fontastic/fonts ./dist/tiime-components",
    "copy-assets:tiime-components": "mkdir -p ./dist/tiime-components/assets && cp -R ./projects/tiime-components/src/assets ./dist/tiime-components",
    "copy-fonts-win:tiime-components": "xcopy /e .\\projects\\tiime-components\\src\\lib\\tiime-fontastic\\fonts .\\dist\\tiime-components\\fonts\\",
    "copy-assets-win:tiime-components": "xcopy /e .\\projects\\tiime-components\\src\\assets .\\dist\\tiime-components\\assets\\",
    "generate-release-id": "bash ./scripts/generate-release-id.sh"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.45.8",
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/material-moment-adapter": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@auth0/auth0-angular": "^2.6.0",
    "@manakincubber/tiime-tracking": "^22.0.0",
    "@manakincubber/tiime-utils": "^22.0.2",
    "@ngneat/input-mask": "^6.1.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@sentry/angular": "^10.74.0",
    "@sentry/cli": "^3.7.0",
    "@sentry/tracing": "^7.120.4",
    "@zip.js/zip.js": "^2.15.0",
    "inputmask": "^5.0.10",
    "libphonenumber-js": "^1.12.36",
    "lodash.clonedeep": "^4.5.0",
    "moment": "^2.31.0",
    "ng2-pdf-viewer": "^10.2.2",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.2",
    "scroll-into-view-if-needed": "^3.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@amplitude/ampli": "1.36.2",
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.6",
    "@eslint/js": "^10.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@testing-library/angular": "^19.5.0",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/user-event": "^14.6.7",
    "@types/inputmask": "^5.0.7",
    "@types/lodash": "^4.17.25",
    "@types/lodash.clonedeep": "^4.5.9",
    "@types/node": "^24.13.4",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "@typescript-eslint/types": "^8.70.0",
    "@typescript-eslint/utils": "^8.70.0",
    "@vitest/browser": "^4.1.11",
    "@vitest/eslint-plugin": "^1.6.27",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.10.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-simple-import-sort": "^14.0.0",
    "jsdom": "^30.0.1",
    "ng-packagr": "^22.1.1",
    "patch-package": "^8.0.1",
    "playwright": "^1.63.0",
    "postinstall-postinstall": "^2.1.0",
    "prettier": "^3.9.6",
    "tslib": "^2.8.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.0",
    "vitest": "^4.1.11"
  }
}
